import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export interface OperationalCommissionerResult { unitId: string; personId: string | null; previousPersonId: string | null; changed: boolean }

/** Designate (or, with null, clear) a unit's operational commissioner. The server enforces who may do it (an administrator, or the
 *  District Commissioner of the unit's district) and writes both legacy fields and the relationship record together. */
export async function setUnitOperationalCommissioner(unitId: string, personId: string | null): Promise<OperationalCommissionerResult> {
  const call = httpsCallable<{ unitId: string; personId: string | null }, OperationalCommissionerResult>(functions, 'setUnitOperationalCommissionerV1');
  return (await call({ unitId, personId })).data;
}
